import Vue from 'vue'

import 'normalize.css/normalize.css' // a modern alternative to CSS resets

import App from './App.vue'
import router from './router'
import store from './store'
import api from "./http"; //加载api

import i18n from './languages' // internationalization

import * as  dialogDrag from '@/utils/dialogDrag'


import dayjs from 'dayjs'

import VueContextMenu from 'vue-contextmenujs';

import './styles/element-variables.scss'

import "./assets/fonts/iconfont.css";

import './permission'//菜单权限控制

import '@/styles/index.scss' // global css

import {
  EventBus
} from "@/utils/event-bus.js";
import MapLoader from "@/utils/map_loader"
//自定义组件
import KLLabel from "@/components/KLLabel";
import KLInfo from "@/components/KLInfo";
import KLIcon from "@/components/KLIcon";
import KLEmpty from "@/components/KLEmpty";
import KLPagination from "@/components/KLPagination";

import { SocketClient } from "@/utils/socket/SocketClient";


import { resetForm } from "@/utils/longyi";

import JsonExcel from 'vue-json-excel'

Vue.component('downloadExcel', JsonExcel)

Vue.use(VueContextMenu);
Vue.use(dialogDrag);

Vue.config.productionTip = false
Vue.use(api);


Vue.prototype.socketClient = new SocketClient();
Vue.prototype.resetForm = resetForm

Vue.component("kl-label", KLLabel);
Vue.component("kl-info", KLInfo);
Vue.component("kl-icon", KLIcon);
Vue.component("kl-empty", KLEmpty);

Vue.component("kl-pagination", KLPagination);
Vue.component("kl-pagination", KLPagination);

Vue.config.lang = store.getters.locale


// console.log(store.getters.locale)

dayjs.locale(store.getters.locale);

// console.log(moment().format('LL'));

Vue.prototype.moment = dayjs;
Vue.prototype.$bus = EventBus;

//地图加载，根据不同的类型加载不同的地图
if (store.getters.mapType === 'google') {
  new MapLoader().loadGoogleMap().then(() => {
    console.log('Google Map loaded successfully');
  });
}
if (store.getters.mapType === 'baidu') {
  new MapLoader().loadBaiduMap().then(() => {
    console.log('Baidu Map loaded successfully');
  });
}
if (store.getters.mapType === 'amap') {
  new MapLoader().loadAMap().then(() => {
    console.log('AMap loaded successfully');
  });
}



new Vue({
  i18n,
  router,
  store,
  render: function (h) { return h(App) }
}).$mount('#app')
